module.exports = __webpack_public_path__ + "img/question.ae13cd93.png";